import { useMemo } from 'react';

import { useSelector } from 'src/store/react';
import { selectResultsLocationType } from 'src/store/results/selectors';
import { selectResultsLocationDescription } from 'src/store/selectors';

const getoverrideWithCanonicalLink = (
  resultsLocationType: string,
  resultsLocationDescription: string,
) => {
  if (
    resultsLocationType.toLowerCase() !== 'country' &&
    resultsLocationDescription !== ''
  ) {
    return { where: resultsLocationDescription };
  }
  return {};
};

export const useOverrideWithCanonicalLink = () => {
  const resultsLocationType = useSelector(selectResultsLocationType);
  const resultsLocationDescription = useSelector(
    selectResultsLocationDescription,
  );

  const where = useMemo(
    () =>
      getoverrideWithCanonicalLink(
        resultsLocationType,
        resultsLocationDescription,
      ),
    [resultsLocationType, resultsLocationDescription],
  );

  return where;
};
